import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { Icon, type IconName } from "../Icon";
import { Spacer } from "../Spacer";
import { Pressable } from "./Pressable";
import { BodyText } from "./Text/BodyText";
import type { PressableState } from "./Pressable";
import type React from "react";

interface ChipProps {
  title: string;
  iconName?: IconName;
  iconSize?: number;
  iconPosition?: "left" | "right";
  iconColor?: string;
  // hovered?: boolean;
  size?: "small" | "large";
  onPress?: () => void;
  backgroundColor?: string;
}

export const Chip: React.FC<ChipProps> = ({
  title,
  iconName,
  iconPosition = "left",
  iconSize = 16,
  iconColor = styleConstantsV2.colorBlack,
  backgroundColor,
  // hovered,
  size = "large",
  onPress,
}) => {
  const resolveBackgroundColor = (hovered?: boolean) => {
    if (hovered) {
      return styleConstantsV2.colorGrey30;
    }
    return styleConstantsV2.colorGrey20;
  };

  const resolveBorderRadius = () => {
    return styleConstantsV2.borderRadius30;
  };

  return (
    <Pressable
      flexDirectionRow
      alignItemsCenter
      justifyContentCenter
      paddingHorizontal16
      disabled={!onPress}
      onPress={() => {
        onPress?.();
      }}
      style={(pressableState: Omit<PressableState, "focused">) => {
        const borderRadius = resolveBorderRadius();

        const hasLeftIcon = iconName && iconPosition === "left";
        const hasRightIcon = iconName && iconPosition === "right";

        // const backgroundColor = resolveBackgroundColor(
        //   onPress ? pressableState.hovered : hovered,
        // );

        return {
          borderRadius,
          backgroundColor:
            backgroundColor || resolveBackgroundColor(pressableState.hovered),
          alignSelf: "flex-start",
          height: 32,
          paddingRight: hasRightIcon ? 8 : 16,
          paddingLeft: hasLeftIcon ? 8 : 16,
        };
      }}
    >
      {iconName && iconPosition === "left" && (
        <>
          <Icon name={iconName} size={iconSize} color={iconColor} />
          <Spacer extraSmall />
        </>
      )}
      <BodyText
        sizeExtraLarge={size === "large"}
        sizeMedium={size === "small"}
        weightBold
        colorBlack
      >
        {title}
      </BodyText>
      {iconName && iconPosition === "right" && (
        <>
          <Spacer extraSmall />
          <Icon name={iconName} size={iconSize} color={iconColor} />
        </>
      )}
    </Pressable>
  );
};
